import * as React from "react";
const SvgSubscriptionRequired = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={80}
    height={80}
    fill="none"
    {...props}
  >
    <path
      fill="url(#subscriptionRequired_svg__a)"
      d="M35.556 2.566a8.89 8.89 0 0 1 8.889 0l25.752 14.868a8.89 8.89 0 0 1 4.444 7.698v29.736a8.89 8.89 0 0 1-4.444 7.698L44.445 77.434a8.89 8.89 0 0 1-8.89 0L9.805 62.566a8.89 8.89 0 0 1-4.445-7.698V25.132a8.89 8.89 0 0 1 4.445-7.698z"
    />
    <path
      fill="#fff"
      d="M22.222 45.842V28.811c0-2.364 1.37-2.933 3.04-1.262l4.605 4.604c.693.694 1.83.694 2.506 0l6.365-6.382c.693-.693 1.83-.693 2.506 0l6.383 6.382c.693.694 1.83.694 2.506 0l4.605-4.604c1.67-1.671 3.04-1.102 3.04 1.262V45.86c0 5.333-3.556 8.889-8.89 8.889H31.112c-4.907-.018-8.889-4-8.889-8.907"
    />
    <defs>
      <linearGradient
        id="subscriptionRequired_svg__a"
        x1={74.641}
        x2={5.359}
        y1={40}
        y2={40}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#082B60" />
        <stop offset={1} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgSubscriptionRequired;
